import { render, staticRenderFns } from "./printDocA4.vue?vue&type=template&id=7620bb62"
import script from "./printDocA4.vue?vue&type=script&lang=js"
export * from "./printDocA4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports